import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import adminRoutes from "./app/routes/admin";
import Layout from "./app/layout";
import useAuth from "./app/hooks/useAuth";
import "./App.css";
import ToasterContainer from "./app/components/toaster";
import Login from "./app/views/auth/Login";
import { Analytics } from "@vercel/analytics/react"

function App() {
  const {user}  = useAuth();
  return (
    <BrowserRouter>
      <ToasterContainer />
      <Analytics />
      <Routes>
        <Route
          path="/login"
          element={user?.Token ? <Navigate to="/dashboard" replace /> : <Login />}
        />
        <Route
          path="/"
          element={<Navigate to={user?.Token ? "/dashboard" : "/login"} replace />}
        />
        <Route
          element={user?.Token ? <Layout /> : <Navigate to="/login" replace />}
        >
          {adminRoutes.map((item) => (
            <Route key={item.path} path={item.path} element={item.component} />
          ))}
        </Route>
        <Route
          path="*"
          element={<Navigate to={user?.Token ? "/dashboard" : "/login"} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
